/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from 'react';

import Estado from './Estado';

import jQuery from 'jquery';

const $ = window.$ = window.jQuery = jQuery;

export default class extends Component {
    constructor(props){
        super(props);
        this.state = {
            elegido: false,
            estados: []
        };
    }

    changeEstado(estado) {
        this.setState({
            elegido: estado
        }, () => {
            $("#nombre-estado").text(estado);
        });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            estados: nextProps.estados
        });
    }

    componentDidMount() {
        this.setState({
            estados: this.props.estados
        });
    }

    render() {
        let codigo = [];
        this.state.estados.forEach((estado, i) => {
            let execute = i === 0;
            if (this.state.elegido) {
                execute = this.state.elegido === estado;
            }
            codigo.push(
                <li key={estado} onClick={() => this.changeEstado(estado)}>
                    <Estado estado={estado} execute={execute}/>
                </li>
            );
        });
        return <ul>{codigo}</ul>;
    }
}


// WEBPACK FOOTER //
// ./src/components/ListaEstados.js